import ApiRoot from '@http/ApiRoot';
import ProductModel from '@models/ProductModel';
import DrawModel from '@models/DrawModel';
import LotteriesEnum from '@data/lotteries';

export default async function () {
  try {
    let inventory;
    if (window.inventoryLoading instanceof Promise) {
      inventory = await window.inventoryLoading;
    }

    if (!inventory) {
      window.inventoryLoading = new Promise((resolve, reject) => {
        window.inventoryLoadingResolve = resolve;
        window.inventoryLoadingReject = reject;
      });

      inventory = await ApiRoot.get('/inventory', {
        cache: {
          maxAge: 30000 // 30s
        }
      });

      window.inventoryLoadingResolve(inventory);
      window.inventoryLoading = null;
    }

    if (!inventory || !inventory.productsOnSale) return null

    const draws = []
      .concat(
        inventory.portalDrawsOnSale || [],
        inventory.customDrawsOnSale || []
      )
      .sort((a, b) => {
        return a.drawDate > b.drawDate || (a.drawDate === b.drawDate) - 1
      })

    return inventory.productsOnSale.map((product) => {
      product = new ProductModel(product)

      const nextDraw = draws.find(
        (draw) =>
          draw.lotteryID === product.lotteryID &&
          draw.drawNumber === product.drawNumber
      )

      product.lottery = LotteriesEnum.find((lot) => lot.special === nextDraw.isEspecial && lot.id === product.lotteryID)

      product.nextDraw = nextDraw ? new DrawModel(nextDraw) : null
      return product
    })
  } catch (err) {
    console.error(err)
    window.inventoryLoadingReject();
    return new Error(err);
  }
}
